
/**
 * @group Configuration
 */
export type TEraserConfiguration = {
  "erase-precisely": boolean
}

/**
 * @group Configuration
 */
export const DefaultEraserConfiguration: TEraserConfiguration = {
  "erase-precisely": false
}
